"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.init = void 0;
var ts_exhaustive_check_1 = require("ts-exhaustive-check");
var AppointmentEditorState = __importStar(require("../appointment-editor/appointment-editor-state"));
function init() {
    return {
        appointmentEditorState: undefined,
        showFilter: false,
        filteredResources: undefined,
    };
}
exports.init = init;
// function formatDateString(date: Date): string {
//   return date.toISOString().substr(0, 10);
// }
function reducer(state, action) {
    switch (action.type) {
        case "OpenAppointmentDialog": {
            var _a = action.payload, appointmentId = _a.appointmentId, personId = _a.personId, userName = _a.userName, start = _a.start, end = _a.end, notes = _a.notes;
            return __assign(__assign({}, state), { appointmentEditorState: AppointmentEditorState.init(appointmentId, personId, userName, start, end, notes) });
        }
        case "CloseAppointmentDialog": {
            return __assign(__assign({}, state), { appointmentEditorState: undefined });
        }
        case "DispatchAppointmentEditor": {
            if (!state.appointmentEditorState) {
                return state;
            }
            return __assign(__assign({}, state), { appointmentEditorState: AppointmentEditorState.reducer(state.appointmentEditorState, action.action) });
        }
        case "SetFilteredResources": {
            return __assign(__assign({}, state), { filteredResources: action.resources });
        }
        case "ClearFilteredResources": {
            return __assign(__assign({}, state), { filteredResources: undefined });
        }
        case "ToggleCalendarFilter": {
            return __assign(__assign({}, state), { showFilter: !state.showFilter });
        }
        default:
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(action, true);
    }
}
exports.reducer = reducer;
//# sourceMappingURL=calendar-state.js.map